import { useFullscreenVideoModal } from './useFullscreenVideoModal';

export const COMPACT_LAYOUT = 'compact';
export const FULLSCREEN_LAYOUT = 'fullscreen';

/**
 * Обрабатывает выбор формата отображения видео из попапа ControlBar.
 * compact — обычный режим карточки (закрывает fullscreen-модалку, если открыта);
 * fullscreen — открывает fullscreen-модалку.
 * params — дополнительные параметры, прокидываемые в модалку (например, isTeacher).
 */
export const useFullscreenLayout = () => {
	const { open, close } = useFullscreenVideoModal();

	return (mode, params) => {
		if (mode === COMPACT_LAYOUT) {
			close();
			return;
		}

		close();
		open({ layout: mode, ...params });
	};
};
